<template>
  <el-scrollbar ref="scrollbarRef">
    <div id="new-order-form">
      <el-form ref="dataForm" style="margin-bottom: 15rem;" :model="order" label-position="top" require-asterisk-position="right" @submit="submitOrder">
        <div class="container">
          <p class="title mb-4" style="font-size: 24px; font-weight: bold">
            {{ $t('components.order-form.selectedProduct') }}:
            <span>{{ productTitle }}</span>
          </p>

          <p v-if="userStore.domain?.urlSuffix === 'luttermann'" class="subtitle">
            {{ $t('components.order-form.companyTitle') }}
          </p>
          <p v-else class="subtitle">{{ $t('components.order-form.customerTitle') }}</p>
          <div class="row">
            <div class="col-md-4" :class="{ 'custom-width': userStore.domain?.urlSuffix === 'luttermann' }">
              <el-form-item
                prop="company"
                :label="$t('views.customize.workflow.form.company')"
                :rules="{
                  required: true,
                  message: $t('error.vuelidate.required'),
                  trigger: ['blur', 'change'],
                }"
              >
                <el-input v-model="order.company" />
              </el-form-item>
            </div>

            <div v-if="userStore.domain?.urlSuffix !== 'luttermann'" class="col-md-4 mb-2">
              <el-form-item
                prop="commissionNo"
                :label="$t('views.customize.workflow.form.commissionNo')"
                :rules="[
                  {
                    required: true,
                    type: 'string',
                    message: $t('error.vuelidate.required'),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model.string="order.commissionNo" />
              </el-form-item>
            </div>

            <div v-if="userStore.domain?.urlSuffix === 'wjtortho'" class="col-md mb-2">
              <el-form-item
                prop="orderNr"
                :label="$t('views.customize.workflow.form.orderNr')"
                :rules="[
                  {
                    required: false,
                    message: $t('error.vuelidate.required'),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="order.orderNr" />
              </el-form-item>
            </div>
          </div>
          <div class="row">
            <div v-if="userStore.domain?.urlSuffix === 'wjtortho'" class="col-md mb-2">
              <el-form-item
                prop="billingNr"
                :label="$t('views.customize.workflow.form.billingNr')"
                :rules="[
                  {
                    required: false,
                    message: $t('error.vuelidate.required'),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="order.billingNr" />
              </el-form-item>
            </div>

            <div v-if="userStore.domain?.urlSuffix === 'wjtortho'" class="col-md mb-2">
              <el-form-item
                prop="customerNr"
                :label="$t('views.customize.workflow.form.customerNr') + ' (WJT GmbH)'"
                :rules="[
                  {
                    required: !noCustomerNr,
                    message: $t('error.vuelidate.required'),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="order.customerNr" :disabled="noCustomerNr" :placeholder="$t('views.customize.workflow.form.input')">
                  <template #append>
                    <el-checkbox v-model="noCustomerNr" :label="$t('views.customize.workflow.form.noCustomerNr')" @change="handleCustomerNr" />
                  </template>
                </el-input>
              </el-form-item>
            </div>
          </div>

          <p class="subtitle">{{ $t('views.customize.workflow.form.contactPerson') }}</p>
          <p v-if="userStore.domain?.urlSuffix === 'luttermann'" class="subsubtitle">
            {{ $t('components.order-form.customerTitle') }}
          </p>
          <div class="row">
            <div class="col-md mb-2">
              <el-form-item
                prop="technicianFirstname"
                :label="$t('views.customize.workflow.form.firstname')"
                :rules="{
                  required: true,
                  message: $t('error.vuelidate.required'),
                  trigger: ['blur', 'change'],
                }"
              >
                <el-input v-model="order.technicianFirstname" />
              </el-form-item>
            </div>

            <div class="col-md mb-2">
              <el-form-item
                prop="technicianLastname"
                :label="$t('views.customize.workflow.form.lastname')"
                :rules="{
                  required: true,
                  message: $t('error.vuelidate.required'),
                  trigger: ['blur', 'change'],
                }"
              >
                <el-input v-model="order.technicianLastname" />
              </el-form-item>
            </div>

            <div class="col-md mb-2">
              <el-form-item
                prop="mail"
                :label="$t('views.customize.workflow.form.mail')"
                :rules="[
                  {
                    required: true,
                    message: $t('error.vuelidate.required'),
                    trigger: 'blur',
                  },
                  {
                    type: 'email',
                    message: $t('error.vuelidate.email'),
                    trigger: ['blur', 'change'],
                  },
                ]"
              >
                <el-input v-model="order.mail" />
              </el-form-item>
            </div>
          </div>


          <div v-if="userStore.domain?.urlSuffix === 'luttermann'" class="row">
            <p class="subsubtitle">{{ $t('components.order-form.technician') }}</p>

            <div class="col-md mb-2">
              <el-form-item
                prop="technician"
                :label="$t('components.order-form.technician')"
                :rules="{
                  required: true,
                  message: $t('error.vuelidate.required'),
                  trigger: 'blur',
                }"
              >
                <el-select v-model="order.technician" :placeholder="$t('components.order-form.pleaseSelect')" style="font-weight: normal">
                  <el-option v-for="item in technicians" :key="item" :label="item" :value="item" />
                </el-select>
              </el-form-item>
            </div>

            <div class="col-md mb-2">
              <el-form-item
                prop="vg-number"
                :label="$t('views.customize.workflow.form.vg-number')"
                :rules="[
                  {
                    message: $t('error.vuelidate.required'),
                    trigger: 'blur',
                  },
                  {
                    type: 'number',
                    message: $t('error.vuelidate.number'),
                    trigger: ['blur', 'change'],
                  },
                ]"
              >
                <el-input v-model="order.vgNumber" />
              </el-form-item>
            </div>

            <div class="col-md mb-2">
              <el-form-item
                prop="vsg-number"
                :label="$t('views.customize.workflow.form.vsg-number')"
                :rules="[
                  {
                    message: $t('error.vuelidate.required'),
                    trigger: 'blur',
                  },
                  {
                    type: 'number',
                    message: $t('error.vuelidate.number'),
                    trigger: ['blur', 'change'],
                  },
                ]"
              >
                <el-input v-model="order.vsgNumber" />
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item
                class="col-md-4"
                prop="customerNr"
                :label="$t('views.customize.workflow.form.customerNr') + ' (bei Luttermann)'"
                :rules="[
                  {
                    required: !noCustomerNr,
                    message: $t('error.vuelidate.required'),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input v-model="order.customerNr" :disabled="noCustomerNr" :placeholder="$t('views.customize.workflow.form.input')">
                  <template #append>
                    <el-checkbox v-model="noCustomerNr" :label="$t('views.customize.workflow.form.noCustomerNr')" @change="handleCustomerNr" />
                  </template>
                </el-input>
              </el-form-item>
            </div>
          </div>

          <FenceSunServices :order="order" class="fenceServices" v-if="selectedModel?.product?.name?.toLowerCase().includes('pv-zaun')" />

          <div class="row">
            <!-- Data upload -->
            <div v-if="isUploadData" class="col-md mb-2">
              <OrderFormUploadData
                :order="order"
                :title="$t('components.order-form.dataUploadTitle')"
                :fields="uploadDataFields"
                :isVisible="isUploadData"
                @progress="handleUploadProgress"
              />
            </div>

            <!-- S-Cover: remarks & policy -->
            <div v-if="selectedModel?.product?.name?.toLowerCase().includes('s-cover')" class="col-md-6 mb-2" style="margin-top: 2.2rem">
              <div class="row">
                <div class="col-md-9">
                  <el-form-item prop="remarks" :label="$t('components.order-form.remarks')">
                    <el-input v-model="order.remarks" :autosize="{ minRows: 2, maxRows: 5 }" class="mt-2 mb-2" type="textarea" style="width: 100%" />
                  </el-form-item>
                </div>
                <div class="col-md-3">
                  <el-form-item
                    prop="privacy"
                    :label="$t('views.customize.workflow.form.privacy')"
                    :rules="{
                      required: true,
                      message: $t('error.vuelidate.required'),
                      trigger: ['blur', 'change'],
                    }"
                  >
                    <el-checkbox v-model="order.isPrivacyAccepted" @change="privacyChanged">
                      {{ $t('views.customize.workflow.form.privacySettings.info') }}
                      <br />
                      <a href="https://www.wako3d.com/datenschutzerklaerung/" target="_blank" rel="noopener noreferrer">
                        {{ $t('views.customize.workflow.form.privacy') }}.
                      </a>
                    </el-checkbox>
                    <el-input v-model="order.privacy" style="visibility: hidden; width: 0; height: 0" />
                  </el-form-item>
                </div>
              </div>
            </div>

            <!-- normal layout -->
            <div v-else class="col-md-6" style="margin-top: 2.2rem">
              <el-form-item prop="remarks" :label="$t('components.order-form.remarks')">
                <el-input v-model="order.remarks" :autosize="{ minRows: 2, maxRows: 5 }" class="mt-2 mb-2" type="textarea" />
              </el-form-item>

              <el-form-item
                prop="privacy"
                :label="$t('views.customize.workflow.form.privacy')"
                :rules="{
                  required: true,
                  message: $t('error.vuelidate.required'),
                  trigger: ['blur', 'change'],
                }"
              >
                <div style="display: flex; align-items: flex-start; gap: 0.5rem">
                  <el-checkbox v-model="order.isPrivacyAccepted" @change="privacyChanged" />
                  <div class="privacy-text">
                    {{ $t('views.customize.workflow.form.privacySettings.info') }}
                    <a href="https://www.wako3d.com/datenschutzerklaerung/" target="_blank" rel="noopener noreferrer" style="display: inline">
                      {{ $t('views.customize.workflow.form.privacy') }}.
                    </a>
                  </div>
                </div>
                <el-input v-model="order.privacy" style="visibility: hidden; width: 0; height: 0" />
              </el-form-item>
            </div>
          </div>

          <div v-if="isSupplierOrReseller() || openProducers.includes(supplier!)" class="row" style="justify-content: flex-end; text-align: right">
            <p class="subtitle" style="margin-top: 1rem">
              {{ $t('components.order-summary.priceTitle') }}
            </p>
            <div style="font-size: 15px">
              <strong>{{ $t('components.order-summary.productPrice') }}</strong>
              {{ price.toFixed(2) }} €
            </div>
          </div>

          <div class="row">
            <!-- Section with Back + Buy Now buttons -->
            <div class="section-group end">
              <!-- Left side (Back button) -->
              <div class="left-button">
                <el-form-item>
                  <!-- Instead of calling goBack(), emit an event so the parent can set step=3 or step-- -->
                  <button class="btn btn-primary" type="button" @click.prevent="handlePreviousStepWhileUploading">
                    {{ $t('components.embossing-footer.backButton') }}
                  </button>
                </el-form-item>
              </div>

              <!-- Right side (Buy Now Button) -->
              <div class="right-button">
                <el-form-item v-if="isUser()">
                  <button type="button" class="btn" @click="downloadOffer">
                    {{ $t('components.order-form.downloadOffer') }}
                  </button>
                </el-form-item>

                <el-form-item v-else-if="isSupplierOrReseller() || openProducers.includes(supplier!) || sendingOrder">
                  <span style="display: inline-block">
                    <el-tooltip
                      v-if="state.isLoadingUploadData"
                      :content= "$t('components.order-form.waitForUpload')"
                      effect="dark"
                      placement="top"
                      popper-class="large-tooltip"
                    >
                      <span>
                        <button class="btn btn-primary" type="submit" :disabled="true">
                          {{ $t('components.order-form.buyNow') }}
                        </button>
                      </span>
                    </el-tooltip>

                    <button v-else class="btn btn-primary" type="submit">
                      {{ $t('components.order-form.buyNow') }}
                    </button>
                  </span>
                </el-form-item>

                <el-form-item v-else>
                  <el-tooltip effect="dark" :content="$t('components.order-form.loginNeeded')" placement="top" popper-class="large-tooltip">
                    <span style="display: inline-block">
                      <button class="btn" type="submit" :disabled="!userStore.isAuthenticated || userStore.roles.includes(Role.User)">
                        {{ $t('components.order-form.buyNow') }}
                      </button>
                    </span>
                  </el-tooltip>
                </el-form-item>
              </div>
              <div
                v-if="!orderSummaryVisible"
                class="scroll-btn d-flex justify-content-center align-items-center"
                type="button"
                @click="scrollToSection"
              >
                <div class="p-3">
                  {{ $t('components.order-summary.title') }}
                  <br />
                  <el-icon :size="30" class="d-grid align-self-center m-auto">
                    <ArrowDown />
                  </el-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <div ref="targetSection">
        <OrderSummary
          :order="order"
          :product="selectedModel?.product"
          :price="price"
          :mesh-tree-data="meshTreeData"
          :selected-colors="selectedColors"
          :selected-engravings="selectedEngravings"
          :selected-textures="selectedTextures"
          :selected-engraving-colors="selectedEngravingColors"
          :selected-texture-colors="selectedTextureColors"
          :screen-shots="screenShots"
        />
      </div>
    </div>
  </el-scrollbar>
</template>

<script lang="ts">
import { OrderRequestData } from '@/services/api/orderService';
import { Vue, Component, Ref, Prop } from 'vue-facing-decorator';
import ValidationForm from '@/components/forms/ValidationForm.vue';
import { BodySide, ZipType } from '@/types/enum/order';
import { LinearLightNameType } from '@/types/enum/order';
import ProductParameterCover from '@/components/productParameters/ProductParameterCover.vue';
import ProductParameterCuboid from '@/components/productParameters/ProductParameterCuboid.vue';
import ProductParameterBalcony from '@/components/productParameters/ProductParameterBalcony.vue';
import ProductParameterFence from '@/components/productParameters/ProductParameterFence.vue';
import ProductParameterOrthesis from '@/components/productParameters/ProductParameterOrthesis.vue';
import ProductParameterBrace from '@/components/productParameters/ProductParameterBrace.vue';
import ProductParameterTemplate from '@/components/productParameters/ProductParameterTemplate.vue';
import ProductParameterLinearLight from '@/components/productParameters/ProductParameterLinearLight.vue';
import ProductParameterBathtub from '@/components/productParameters/ProductParameterBathtub.vue';
import Auth from '@/services/api/auth';
import MeasurementInfoCard from '@/components/productParameters/MeasurementInfoCard.vue';
import { removeWordFromString } from '@/utils/formBuilder';
import OrderFormUploadData from '@/components/forms/OrderFormUploadData.vue';
import * as UserService from '@/services/api/userService';
import formUploadDataInitial from '@/data/formUploadDataInitial.json';
import { RGB } from 'three';
import { SupportedValues } from '@/types/api/Utility/FileTexture';
import { Model2 } from '@/types/api/Model/Model';
import { ElForm, ElMessage, ElMessageBox, ScrollbarInstance } from 'element-plus';
import { kneeJointOptionsDefault } from '@/types/constants';
import { Role } from '@/types/enum/user';
import { useUserStore } from '@/stores/userStore';
import FenceSunServices from '@/views/order/FenceSunServices.vue';
import { reactive, watch } from 'vue';
import { useUploadStore } from '@/stores/uploadStore';
import OrderSummary from './OrderSummary.vue';
import { MeshTreeData } from '@/types/ui/MeshTreeData';
import { RGB2 } from '@/types/api/Utility/RGB2';
import { File as UtilityFile } from '@/types/api/Utility/File';
import { Modal } from 'bootstrap';
import { WithI18n } from '@/types/ui/Global';
import { addCoverOrder, createOrder, updateCoverOrder } from '@/services/api/newOrderService';
import { checkUserSession, getDomainByUrlSuffix } from '@/services/api/userService';
import { useComponentSettingStore } from '@/utils/componentSettings';

@Component({
  components: {
    ValidationForm,
    MeasurementInfoCard,
    ProductParameterCover,
    ProductParameterCuboid,
    ProductParameterBalcony,
    ProductParameterFence,
    ProductParameterOrthesis,
    ProductParameterBrace,
    ProductParameterTemplate,
    ProductParameterLinearLight,
    ProductParameterBathtub,
    OrderFormUploadData,
    FenceSunServices,
    OrderSummary
  },
  emits: ['zipChanged', 'sizeChanged', 'confirmOfferPdf', 'confirmOfferPdfV2', 'confirmPartListPdfV2', 'onSubmit', 'previousStep'],
})

export default class OrderForm extends Vue {
  @Prop() order!: OrderRequestData;
  @Prop() selectedModel!: Model2;
  @Prop() selectedColors!: RGB2[];
  @Prop() selectedEngravings!: UtilityFile[];
  @Prop() selectedEngravingColors!: RGB2[];
  @Prop() selectedTextures!: UtilityFile[];
  @Prop() selectedTextureColors!: RGB2[];
  @Prop() meshTreeData!: MeshTreeData[];
  @Prop() screenShots!: string[];
  @Prop({ default: [] }) meshEngravings!: SupportedValues[];
  @Prop() meshEmbossingColors!: RGB[];
  @Prop() meshColors!: RGB[];
  @Prop() meshTextureColors!: RGB[];
  @Prop() sendingOrder!: boolean;
  @Prop({ default: false }) loadingOfferPdf!: boolean;
  @Prop({ default: false }) isLoadingButtonPartList!: boolean;
  @Prop({ default: 0 }) price!: number;

  authentication = Auth.getInstance();
  userStore = useUserStore();
  uploadStore = useUploadStore();

  @Ref() readonly targetSection!: HTMLElement
  @Ref() readonly scrollbarRef!: ScrollbarInstance;
  observer: IntersectionObserver | null = null;
  orderSummaryVisible = false;

  loadingPartListPdf = false;

  state = reactive({
    isLoadingUploadData: false,
  });

  Role = Role;

  BodySide = BodySide;
  ZipType = ZipType;
  LinearLightNameType = LinearLightNameType;

  isValidationError = false;
  noCustomerNr = false;

  private measurementInfoModalDialog: Modal | null = null;
  selectedContent: string | null = null;
  localColor = 'Schwarz';

  settingStore = useComponentSettingStore();

  technician = '';

  technicians = [
    'Christa Becker',
    'Ralf Huppelsberg',
    'Philippe Knieps',
    'Christoph Emschermann',
    'Dennis Hewitt',
    'Guido Grünke',
    'Niklas Hirsch',
    'Moritz Engelhardt',
    'Florian Kalkmann',
  ];

  supplier: string | null = null;
  openProducers = ['bayer', 'gartner-metall', 'sunfence', 'kraftwerk4you', 'steellook'];

  selectedMeshColor: RGB | null = null;
  selectedMeshEmbossingColor: RGB | null = null;
  selectedMeshTextureColor: RGB | null = null;

  kneeJointOptionsDefault = kneeJointOptionsDefault;
  withCalculation = true;
  removeWordFromString = removeWordFromString;

  combinedColors: Partial<RGB & { type: string }>[] = [];

  handleUploadProgress(isUploading: boolean) {
    this.state.isLoadingUploadData = isUploading;
    this.uploadStore.setIsUploading(isUploading);
  }

  handlePreviousStepWhileUploading(){
    if (this.state.isLoadingUploadData) {
      ElMessageBox.confirm(
        (this as WithI18n).$t('components.order-form.goBackWhileLoadingMessage'),
        'info',
        {
          confirmButtonText: (this as WithI18n).$t('components.mesh-loader.yes'),
          cancelButtonText: (this as WithI18n).$t('components.mesh-loader.no'),
          type: 'warning',
        }
      )
        .then(() => {
          this.$emit('previousStep');
        })
        .catch((err) => {
          console.log('User canceled going back while uploading:', err);
        });
    } else {
      this.$emit('previousStep');
    }
  }

  get isUploadData(): boolean {
    return (
      (this.selectedModel?.product?.name?.toLowerCase().includes('cover') 
      || this.selectedModel?.product?.name?.toLowerCase().includes('prothesenschaft')
      || this.selectedModel?.product?.name?.toLowerCase().includes('korsett')
       && !this.selectedModel?.product?.name?.toLowerCase().includes('s-cover') || false)
    );
  }

  submitOrder(event: Event | null = null): void {
    if (event) event.preventDefault();
    const dataForm = this.$refs.dataForm as typeof ElForm;
    dataForm?.validate(async (valid: boolean) => {
      if (valid) {
        this.$emit('on-submit');
      } else {
        ElMessage({
          showClose: true,
          message: (this as WithI18n).$t('views.customize.workflow.form.error'),
          type: 'error',
          duration: 4000,
        });
      }
    });
  }

  downloadOffer(): void {
    const dataForm = this.$refs.dataForm as typeof ElForm;
    dataForm.validate((valid: boolean) => {
      if (valid) {
        this.$emit('confirm-offer-pdf-v2');
      } else {
        ElMessage({
          showClose: true,
          message: this.$t('views.customize.workflow.form.error'),
          type: 'error',
          duration: 4000,
        });
      }
    });
  }

  isSupplierOrReseller(): boolean {
    return this.userStore.isAuthenticated && (this.userStore.roles.includes(Role.Reseller) || this.userStore.roles.includes(Role.Supplier));
  }

  isUser(): boolean {
    return this.userStore.isAuthenticated && this.userStore.roles.includes(Role.User) && !this.isSupplierOrReseller();
  }

  // Watch or handle changes to the "no customer number" checkbox
  handleCustomerNr() {
    if (this.noCustomerNr) {
      this.order.customerNr = '';
    }
  }

  // If a privacy checkbox is toggled
  privacyChanged(): void {
    if (this.order.isPrivacyAccepted) {
      this.order.privacy = 'yes';
    } else {
      this.order.privacy = '';
    }
  }

  triggerCheckboxGrow(): void {
    this.isValidationError = true;
    setTimeout(() => (this.isValidationError = false), 250);
  }

  // A modal show example (if you need it)
  showMeasurementInfoModalDialog(content: string): void {
    this.selectedContent = content;
    this.measurementInfoModalDialog?.show();
  }


  //idk we we need that but since the getUploadDataFields return an error i won't delete it
  addScanFile(event: { target: { files: any; }; }) {
    for (const scan of event.target.files) {
      this.order.scanFiles.push(scan);
    }
  }

  addImageFiles(event: { target: { files: any; }; }) {
    for (const image of event.target.files) {
      this.order.imageFiles.push(image);
    }
  }
  
  get uploadDataFields() {
    const addParams = [{ group: 'string', id: 'number' }];

    return formUploadDataInitial.map((row, index) => {
      const methodName = row.action; // Get the function name from the JSON file
      const method = (this as OrderForm)[methodName as keyof OrderForm]; // Search for functions in the component
      const params = row.params || addParams[index]; // Ambil parameter tambahan dari JSON

      if (typeof method !== 'function') {
        console.error(`Method "${methodName}" not found on the component.`);
        return { ...row, action: undefined }; // Set undefined if the function is not found
      }

      //  Wrap the function with a closure to pass additional parameters
      return {
        ...row,
        action: (event: Event) => method(event, { ...params }),
      };
    });
  }

  // Combine available color options if you need them
  updateCombinedColors() {
    this.combinedColors = [
      // e.g., only mesh (3D model) colors are used
      ...this.meshColors.map((c) => ({ ...(c as RGB), type: 'colors' })),
    ];
  }

  // Remove the "phase1" text from product name
  get productTitle(): string {
    return removeWordFromString(this.selectedModel?.product?.name, 'phase1');
  }


  // Initialize on mount
  async mounted(): Promise<void> {
    window.scrollTo(0, 0);
    this.updateCombinedColors();

    if (this.userStore.isAuthenticated) {
      this.state.isLoadingUploadData = true;
      await createOrder(this.order, this.selectedModel, true);
      this.state.isLoadingUploadData = false;
    }
    
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.orderSummaryVisible = entry.isIntersecting
      },
      {
        root: null, // viewport
        threshold: 0.1,
      }
    )

    if (this.targetSection) {
      this.observer.observe(this.targetSection)
    }

    const urlParams = new URLSearchParams(window.location.search);
    this.supplier = urlParams.get('supplier');

    const isLuttermann = this.userStore.domain?.urlSuffix === 'luttermann';
    this.order.company = isLuttermann ? 'Luttermann GmbH' : '';

    this.order.isPrivacyAccepted = false;
    this.privacyChanged();

    watch(
      () => this.userStore.user,
      (newUser) => {
        if (newUser) {
          this.order.mail = newUser.email ?? '';
          this.loadUser();
        }
      },
      { immediate: true }
    );
  }

  unmounted(): void {
    if (this.observer && this.targetSection) {
      this.observer.unobserve(this.targetSection)
    }
  }

  scrollToSection() {
    this.scrollbarRef.scrollTo({
      top: this.targetSection.offsetTop,
      behavior: 'smooth',
    });
  }

  async loadUser(){
    try {
      const user = await UserService.getUserByEmail(this.order.mail);
      const firstname = user.firstname;
      const lastname = user.lastname;
      this.order.technicianFirstname = firstname;
      this.order.technicianLastname = lastname;
    } catch (error) {
      console.error("Failed to load user:", error);
    }
  }
}
</script>

<style lang="scss">
.large-tooltip {
  font-size: 14px;
  font-weight: bold;
}

.fenceServices {
  margin-left: -12px !important;
}

.el-scrollbar__view {
  display: initial;
}

#new-order-form {
  justify-self: right;
  align-self: end;
  background: #fff;
  padding: 4rem;
  width: 100%;

  p {
    margin-bottom: 5px;
  }

  .title {
    font-size: 24px;
    font-weight: bold;
  }

  .subtitle {
    color: hsl(0, 0%, 29%);
    font-size: 18px !important;
    font-weight: 600;
    margin-top: 1rem !important;
    margin-bottom: 0.5rem !important;
  }

  .subsubtitle {
    color: hsl(0, 0%, 29%);
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 0.5rem !important;
  }

  .danger {
    color: #d93222;
  }

  .el-form-item {
    margin-top: 0.5rem;
    font-weight: normal;
    color: var(--color-primary);
  }

  .section-group {
    margin-top: 0.5rem;
  }

  .section-group.end {
    display: flex;
    justify-content: flex-end;
    margin-top: 1.5rem;
    gap: 10px;

    .btn {
      background-color: var(--color-primary);
      color: var(--primary-text);
      border-radius: 5px !important;
      padding: 10px 50px !important;
    }
  }

  .form-group {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    .flex-1 {
      flex: 1;
    }
  }

  .w-full {
    width: 100%;
  }

  .privacy-text {
    color: hsl(0, 0%, 29%);
    max-width: 100%;
    word-break: break-word;
    white-space: normal;
    line-height: 1;
    align-self: center;
  }
}

.scroll-btn {
  position: fixed;
  bottom: 2%;
  left: calc(50% - 34px);
  z-index: 1000;
  backdrop-filter: blur(5px);
  background-color: #ffffff50;
  border-radius: 1rem;
  transition: all 0.1s ease-in-out;
  font-size: 1rem;
}

.scroll-btn:hover {
  background-color: #cccccc50;
  transform: scale(1.03);
}

.left-button {
  margin-right: auto;
}

.right-button {
  display: flex;
  gap: 10px;
  margin-left: auto;
}

@media (max-width: 768px) {
  #new-order-form {
    padding: 1rem;
  }
}
</style>
